var render = function render(){var _vm=this,_c=_vm._self._c;return _c('file-input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],ref:"fileImporter",attrs:{"accept":_vm.accept},on:{"change":_vm.fileSelected}})
}
var staticRenderFns = []

export { render, staticRenderFns }